import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

import { GetEntityById2, GetEntityById2GQL } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

/**
 * Format of data for the dialog
 */
export interface EntityQuickEditDialogData {
  campaignId: string;
  entityId: string;

}

@Component({
  selector: 'app-entity-quick-edit-dialog',
  templateUrl: './entity-quick-edit.dialog.html',
  styleUrls: ['./entity-quick-edit.dialog.scss']
})
export class EntityQuickEditDialog extends WithDisposableSubject()
  implements OnInit {

  entity: GetEntityById2.GetEntity;

  static open(dialog: MatDialog, config: MatDialogConfig<EntityQuickEditDialogData>) {
    return dialog.open(EntityQuickEditDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<EntityQuickEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: EntityQuickEditDialogData,
    private _getEntityGQL: GetEntityById2GQL,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.watchEntity();
  }


  watchEntity() {

    this._getEntityGQL.watch({
      entityId: this.data.entityId,
      campaignId: this.data.campaignId,
      withToplines: true,
      withBestEmail: true,
      withBestPhone: true,
      withBestAddress: true,
      withEmails: true,
      withPhones: true,
      //withSocials: true,
      withAddresses: true,
      withFollowUpDetails: true
    }, {
      fetchPolicy: 'cache-first'
    }).valueChanges
      .pipe(
        takeUntil(this.disposer)
      ).subscribe(
        (res) => {
          this.entity = res.data.getEntity;
          this._cd.markForCheck();
        }
      );
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }
}
